import { Injectable } from "@angular/core";
import { PsMaterialBillingCodes, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PsMaterial {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllPsMaterialBillingCodes();
    }

    getAllPsMaterialBillingCodes() {
        return this.powerSupplyService.getAllPsMaterialBillingCodes().pipe(map(result => result));
    }

    createPsMaterialBillingCodes(model: PsMaterialBillingCodes) {
        return this.powerSupplyService.createPsMaterialBillingCodes(model).pipe(map(result => result));
    }

    updatePsMaterialBillingCodes(model: PsMaterialBillingCodes) {
        return this.powerSupplyService.updatePsMaterialBillingCodes(model).pipe(map(result => result));
    }

    deletePsMaterialBillingCodes(id: number) {
        return this.powerSupplyService.deletePsMaterialBillingCodes(id).pipe(map(result => result));
    }
}
